import { environnement } from "configs/environnement";
import api from "./api";
import {
  IOfferingResponse,
  ISaveOffering,
  IUpdateOffering,
} from "models/church.types";

const BASE_URL = `${environnement.baseURL}/offerings`;

export const OfferingService = {
  /**
   * GET /api/eglise/v1/offerings/_search
   * Utilisation de la recherche comme méthode "getAll" par défaut
   */
  getAll: async (page: number, size: number) => {
    const response = await api.get<IOfferingResponse[]>(`${BASE_URL}/_search`, {
      params: {
        page: page,
        size: size,
        sort: "id,desc",
        query: "", // Paramètre optionnel vide
      },
    });
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  /**
   * POST /api/eglise/v1/offerings
   */
  create: async (offering: ISaveOffering): Promise<IOfferingResponse> => {
    const response = await api.post<IOfferingResponse>(`${BASE_URL}`, offering);
    return response.data;
  },

  /**
   * PUT /api/eglise/v1/offerings
   */
  update: async (offering: IUpdateOffering): Promise<IOfferingResponse> => {
    const response = await api.put<IOfferingResponse>(`${BASE_URL}`, offering);
    return response.data;
  },

  /**
   * GET /api/eglise/v1/offerings/{id}
   */
  getById: async (id: number): Promise<IOfferingResponse> => {
    const response = await api.get<IOfferingResponse>(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * DELETE /api/eglise/v1/offerings/{id}
   */
  delete: async (id: number): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`);
  },

  /**
   * GET /api/eglise/v1/offerings/_search
   */
  search: async (query: string, page: number, size: number) => {
    const response = await api.get<IOfferingResponse[]>(`${BASE_URL}/_search`, {
      params: {
        query: query,
        page: page,
        size: size,
        sort: "id,desc",
      },
    });
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  /**
   * GET /api/eglise/v1/offerings/summary
   * Ajout de la logique pour le résumé financier
   */
  getSummary: async (
    startDate?: string,
    endDate?: string,
    eventId?: number,
  ) => {
    const response = await api.get<number>(`${BASE_URL}/summary`, {
      params: {
        startDate,
        endDate,
        eventId,
      },
    });
    return response.data; // Retourne le montant (BigDecimal)
  },

  /**
   * GET /api/eglise/v1/offerings/event/{eventId}
   */
  getByEvent: async (eventId: number, page: number, size: number) => {
    const response = await api.get<IOfferingResponse[]>(
      `${BASE_URL}/event/${eventId}`,
      {
        params: {
          page: page,
          size: size,
          sort: "id,desc",
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },
};
